function handleNameStr(str) {
  if (!str) {
    return '-';
  }
  let newStr = str.substring(0, 1);
  let extraLen = str.length - 1;
  while (extraLen > 0) {
    newStr += '*';
    extraLen -= 1;
  }
  return newStr;
}

function handlePhoneStr(phone) {
  if (!phone && phone !== 0) {
    return '-';
  }
  const phoneStr = `${phone}`;
  const len = phoneStr.length;

  if (len <= 4) {
    // 号码长度小于等于4位，不隐藏，如110，120，显示为110，120
    return phoneStr;
  } else if (len > 4 && len <= 8) {
    // 号码长度大于4位小于等于8位，后四位显示，前x位隐藏，如 12345 显示为 *2345 ，123456 显示为 **3456 ，12345678 显示为 ****5678
    let targetStr = phoneStr.substr(phoneStr.length - 4);
    let extraLen = len - 4;
    while (extraLen) {
      extraLen -= 1;
      targetStr = `*${targetStr}`;
    }
    return targetStr;
  }
  // 号码长度大于8位，隐藏倒数第4位到第8位之间的数字，如 12345678901 显示为 123****8901
  const endStr = phoneStr.substr(phoneStr.length - 4);
  const startLen = phoneStr.length - 4 - endStr.length;
  const startStr = phoneStr.substr(0, startLen);
  return `${startStr}${'*'.repeat(4)}${endStr}`;
}

export { handleNameStr, handlePhoneStr };



// WEBPACK FOOTER //
// ./src/common/desensitization.js